var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SettingGroup',[_c('SettingItem',{attrs:{"label":"GPS レポートの間隔"}},[_c('SelectBox',{attrs:{"disabled":false,"options":_vm.selectboxOptions.gpsReportIntervalTime,"defaultValue":String(_vm.form.selectbox.gpsReportIntervalTime)},on:{"update":_vm.handleSelect}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }